/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@eureca/candidate-api-sdk/client';
import type {
  GetProgramQueryResponse,
  GetProgramPathParams,
  GetProgram404,
  GetProgram503,
} from '../types/GetProgram.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@eureca/candidate-api-sdk/client';

function getGetProgramUrl(id: GetProgramPathParams['id']) {
  const res = { method: 'GET', url: `/programs/${id}` as const };
  return res;
}

/**
 * {@link /programs/:id}
 */
export async function getProgram(
  id: GetProgramPathParams['id'],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetProgramQueryResponse,
    ResponseErrorConfig<GetProgram404 | GetProgram503>,
    unknown
  >({ method: 'GET', url: getGetProgramUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
